import {
  WorkIntegration_Keys,
  type WorkIntegrationResponse,
} from '@/common/api/types/workIntegrations';
import { useFlag } from '@/common/hooks/feature-flags/useFlag';

export const useIsAdoPushGated = (
  sourceSystemType: WorkIntegrationResponse['sourceSystemType'] | undefined,
): boolean => {
  const workIntegrationAdoPush = useFlag('workIntegrationAdoPush');
  return sourceSystemType === WorkIntegration_Keys.ADO && !workIntegrationAdoPush;
};
